export const adacThemeConfig = {
    name: 'adacTheme',
    prefix: 'adacTheme',
    rootStyle: {
        // ADAC vars
        '--ADAC-YELLOW': 'rgb(255, 204, 0)',
        '--ADAC-BLACK': 'rgba(0,0,0,.9)',
        '--ADAC-DARK-GRAY': 'rgba(0,0,0,.6)',
        '--ADAC-LIGHT-GRAY': 'rgba(0,0,0,.1)',
        '--ADAC-XLIGHT-GRAY': 'rgba(0,0,0,.04)',
        '--ADAC-RED': 'rgb(220,8,8)',
        '--ADAC-FONT-MILO-SLAB': 'MiloSlabADAC',
        '--ADAC-FONT-MILO': 'MiloADAC',

        // Root styles
        '--GW-BRAND-COLOR-1': 'var(--ADAC-YELLOW)',
        '--GW-COLOR-INFO': 'var(--GW-BRAND-COLOR-1)',
        '--GW-MODAL-HEADER-ICON-SIZE': '3rem',
        '--GW-FONT-FAMILY': 'var(--ADAC-FONT-MILO)',
        '--GW-HEADER-COLOR': 'var(--ADAC-BLACK)',
        '--GW-HEADER-BACKGROUND-COLOR': 'var(--GW-BRAND-COLOR-1)',
        '--GW-FONT-SIZE-H1': '1.8rem',
        '--GW-FONT-SIZE-H2': '1.3rem',
        '--GW-FONT-SIZE-H3': '1rem',
        '--GW-FONT-SIZE-BODY': '1rem',
        '--GW-FONT-SIZE-LABEL': '1rem',
        '--GW-FONT-SIZE-INPUT': '1rem',
        '--GW-TEXT-COLOR-1': 'var(--ADAC-BLACK)',
        '--GW-BACKGROUND-COLOR-BODY': 'none',

        '--GW-RADIO-BUTTON-CARD-LANDSCAPE-ICON-SIZE': '1.5rem',
        '--GW-BORDER-COLOR': 'var(--ADAC-LIGHT-GRAY)',
        '--GW-FIELD-COMPONENT-COLOR': 'var(--ADAC-BLACK)',
        '--GW-FIELD-COMPONENT-BACKGROUND-COLOR': 'var(--ADAC-XLIGHT-GRAY)',
        '--GW-BORDER-RADIUS': '.25rem',
        '--GW-FOCUS-COLOR-LIGHT': 'transparent',
        '--GW-SHADOW-2': 'none',
        '--GW-SHADOW-3': 'none',
        '--GW-CLICKABLE-ELEMENT-BACKGROUND-COLOR': 'transparent',
        '--GW-CLICKABLE-ELEMENT-BACKGROUND-COLOR-ACTIVE': 'transparent',
        '--GW-FIELD-COMPONENT-HEIGHT': '3.5rem',
        '--GW-FIELD-COMPONENT-BORDER-COLOR-FOCUS': 'var(--ADAC-XLIGHT-GRAY)',
        '--GW-SELECTOR-SELECTED-BACKGROUND-COLOR': 'var(--ADAC-BLACK)',
        '--GW-SELECTOR-SELECTED-BACKGROUND-COLOR-HOVER': 'var(--ADAC-BLACK)',
        '--GW-SELECTOR-SELECTED-BACKGROUND-COLOR-ACTIVE': 'var(--ADAC-BLACK)',
        '--GW-SELECTOR-COLOR-FOCUS': 'var(--GW-FIELD-COMPONENT-COLOR)',
        '--GW-SELECTOR-BACKGROUND-COLOR-HOVER': 'transparent',
        '--GW-SELECTOR-BACKGROUND-COLOR-ACTIVE': 'transparent',
        '--GW-BACKGROUND-COLOR-HOVER': 'transparent',
        '--GW-LAYOUT-6': '.5rem',
        '--GW-SPACING-4': '.5rem',
        '--GW-DROPDOWN-OPTION-BACKGROUND-COLOR-HOVER': 'transparent',
        '--GW-DROPDOWN-OPTION-BACKGROUND-COLOR-ACTIVE': 'transparent',
        '--GW-DROPDOWN-OPTION-SELECTED-BACKGROUND-COLOR-HOVER': 'var(--GW-BRAND-COLOR-1)',
        '--GW-DROPDOWN-OPTION-SELECTED-BACKGROUND-COLOR-ACTIVE': 'var(--GW-BRAND-COLOR-1)',

        // filled Button
        '--GW-BUTTON-FILLED-COLOR': 'var(--ADAC-BLACK)',
        '--GW-BUTTON-FILLED-BACKGROUND-COLOR': 'var(--GW-BRAND-COLOR-1)',
        '--GW-BUTTON-FILLED-BACKGROUND-COLOR-HOVER': 'var(--GW-BRAND-COLOR-1)',
        '--GW-BUTTON-FILLED-BACKGROUND-COLOR-ACTIVE': 'var(--GW-BRAND-COLOR-1)',

        // outlined Button
        '--GW-BUTTON-OUTLINED-COLOR': 'var(--GW-BRAND-COLOR-2)',
        '--GW-BUTTON-OUTLINED-COLOR-HOVER': 'var(--GW-BRAND-COLOR-2)',
        '--GW-BUTTON-OUTLINED-BORDER-COLOR': 'var(--GW-BRAND-COLOR-1)',
        // '--GW-BUTTON-OUTLINED-BORDER-WIDTH': 'var(--GW-BORDER-WIDTH)',
        // '--GW-BUTTON-OUTLINED-BACKGROUND-COLOR': 'var(--GW-BACKGROUND-COLOR)',
        '--GW-BUTTON-OUTLINED-BACKGROUND-COLOR-HOVER': 'var(--GW-BUTTON-OUTLINED-BACKGROUND-COLOR)',
        '--GW-BUTTON-OUTLINED-BACKGROUND-COLOR-ACTIVE': 'var(--GW-BUTTON-OUTLINED-BACKGROUND-COLOR)',
    },
};
